import React from 'react'
import "./Logo.css"

const Logo = () => {
  return (
    <div className="logo font-primary">Darling.</div>
  )
}

export default Logo
